import React from 'react';
import { Icon } from 'semantic-ui-react';
import Radium from 'radium';

const styles = {
	input: {
		width: '100%',
		backgroundColor: 'transparent',
		padding: '0.5em 1em',
		border: '1px solid #43b39e',
		color: '#193449',
		borderRadius: '4px',
		height: '100%',
		':hover': {
			textDecoration: 'none',
		},
		':focus': {
			outline: 'none',
		},
	},
	inputWrapper: {
		height: 40,
		width: '100%',
	},
	icon: {
		position: 'absolute',
		right: 5,
		top: 10,
		color: '#43b39e',
	},
};

let SearchInput = ({
	onChange,
	current,
	resetInput,
	placeholder,
	autoFocus = false,
	...props
}) => {
	if (!current)
		current = '';
	return (
		<div style={styles.inputWrapper}>
			{current === '' && (
				<Icon name='search' size='large' style={{ ...styles.icon, ...props.styleicon }} />
			)}
			{current !== '' && (
				<Icon
					name='close'
					size='large'
					style={{ ...styles.icon, ...props.styleicon, color: '#a51c13' }}
					onClick={(e) => {
						if (e !== undefined) e.preventDefault();
						resetInput();
					}}
				/>
			)}
			<input
				type='text'
				style={styles.input}
				{...props}
				placeholder={placeholder || 'Rechercher'}
				value={current}
				onChange={onChange}
				autoFocus={autoFocus}
			/>
		</div>
	);
};

export default Radium(SearchInput);
